import { Component, Inject, AfterViewInit } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTableModule } from '@angular/material/table';
import { MatDividerModule } from '@angular/material/divider';
import { HolLocation, HolRoot } from '@app/shared/CSDAModels/HOLLocation';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-hol-location-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatTableModule,
    MatDividerModule,
    TranslateModule,
  ],
  templateUrl: './hol-location-dialog.component.html',
  styleUrls: ['./hol-location-dialog.component.scss'],
})
export class HolLocationDialogComponent implements AfterViewInit {
  displayedColumns = [
    'select',
    'address',
    'distance',
    'specialInstruction',
    'openHours',
  ];
  LocationCount = 0;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: HolRoot,
    private dialogRef: MatDialogRef<HolLocationDialogComponent>,
    private translateService: TranslateService,
  ) {}

  ngAfterViewInit(): void {
    this.LocationCount = this.data.Locations.length;
    this.dialogRef.updateSize('calc(100vw - 180px)', 'calc(100vh - 180px)');
  }

  selectLocation(location: HolLocation): void {
    this.dialogRef.close(location);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

  formatAddress(location: HolLocation): string {
    return `${location.City}, ${location.State}, ${location.Country}`;
  }

  formatHours(location: HolLocation): string {
    return location.OpenHours.map(
      (h) => `${h.DayOfWeek.toUpperCase()} - ${h.Begin} to ${h.End}`,
    ).join('\n');
  }

  formatDistance(location: HolLocation): string {
    return `${location.DistanceValue} ${location.DistanceUnit}`;
  }
}
